import { useState } from 'react';
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import s from '../../styles/components/home/MediaPlayer.module.css';

export default function MediaPlayer({ data }) {
    const { label, songs } = data;
    const items = songs;

  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState('next');
  const [animating, setAnimating] = useState(false);

  const item = items[index];
  const offset = direction === 'next' ? -12 : 12;

  const changeSlide = (newIndex, dir) => {
    if (animating) return;
    setDirection(dir);
    setAnimating(true);
    setTimeout(() => {
      setIndex(newIndex);
      setAnimating(false);
    }, 250);
  };

  const showNext = () => changeSlide(index === items.length - 1 ? 0 : index + 1, 'next');
  const showPrev = () => changeSlide(index === 0 ? items.length - 1 : index - 1, 'prev');

  return (
    <section className={s.container}>
      <div className={s.inner}>
        <span className={s.label}>{label}</span>

        <div className={s.row}>
          <button onClick={showPrev} className={s.arrow} aria-label="Previous">‹</button>

          <div className={s.content}>
            <div className={s.cover}>
              <img
                src={item.image}
                alt={item.name}
                className={s.image}
                style={{
                  opacity: animating ? 0 : 1,
                  transform: animating ? `translateX(${offset}px)` : 'translateX(0)',
                  transition: 'opacity 0.35s ease, transform 0.35s ease',
                }}
              />
            </div>

            <div className={s.player}>
                <h2 className={s.title}>{item.name}</h2>
                <p className={s.description}>{item.description}</p>

                <AudioPlayer
                    src={item.audio}
                    layout="stacked"
                    autoPlayAfterSrcChange={false}
                    showJumpControls={false}
                    customVolumeControls={[]}
                    customAdditionalControls={[]}
                    customProgressBarSection={[
                    RHAP_UI.CURRENT_TIME,
                    RHAP_UI.PROGRESS_BAR,
                    RHAP_UI.DURATION,
                    ]}
                    customControlsSection={[
                    RHAP_UI.MAIN_CONTROLS,
                    ]}
                />
                </div>
          </div>

          <button onClick={showNext} className={s.arrow} aria-label="Next">›</button>
        </div>

        <div className={s.dots}>
          {items.map((_, i) => (
            <span
              key={i}
              onClick={() => i !== index && changeSlide(i, i > index ? 'next' : 'prev')}
              style={{ opacity: i === index ? 1 : 0.35 }}
              className={s.dot}
            />
          ))}
        </div>
      </div>
    </section>
  );
}